module.exports = __webpack_public_path__ + "img/pause.080921be.svg";